import script from "./default.vue?vue&type=script&setup=true&lang=js"
export * from "./default.vue?vue&type=script&setup=true&lang=js"

import "./default.vue?vue&type=style&index=0&id=7d10247c&lang=scss&scoped=true"
import "./default.vue?vue&type=style&index=1&id=7d10247c&lang=scss&scoped=true"
import "./default.vue?vue&type=style&index=2&id=7d10247c&lang=scss"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d10247c"]])

export default __exports__